module.exports = __webpack_public_path__ + "static/media/tali_ta.e41457cb.ogg";